import gql from 'graphql-tag';

export default gql`
    mutation generateDietMutation(
        $request: UserDietSettingsValidationFastingInputType!
    ) {
        me {
            generateDiet(settings: $request) {
                __typename
                ... on UnauthorizedException {
                    code
                }
                ... on ValidationException {
                    code
                    messages
                    details {
                        fieldName
                        messages
                    }
                }
                ... on BasicMutationSuccess {
                    code
                }
            }
        }
    }
`;
